module.exports = __webpack_public_path__ + "img/egg_cheese_diff.e14ebfe6.jpg";